import "./App.css";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import Search from "./searchfortravel/Search";
import {
  clearLocalStoragePreservingDeviceId,
  listenForForegroundMessages,
  requestForToken,
} from "./firebase";
import Historycom from "./searchfortravel/Historycom";
import TravelCard from "./searchfortravel/TravelCard";
import Reportcom from "./searchfortravel/Reportcom";
import Logincom from "./LoginRegister/Login";
import Recievecode from "./LoginRegister/Recievecode";
import Everyhistravelcard from "./searchfortravel/Everyhistravelcard";
import Everytravelcard from "./searchfortravel/Everytravelcard";
import UserandCarinf from "./LoginRegister/User&Carinf";
import Messagecom from "./searchfortravel/Messagecom";
import Nav from "./searchfortravel/allcomponent/Nav";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { UseContext } from "./context";
import Supportcom from "../src/searchfortravel/Supportcom";
import Errorpage from "./searchfortravel/allcomponent/404page";
import axios from "axios";
import EditProfile from "./searchfortravel/EditProfile";
import EditDriverProfile from "./LoginRegister/EditDriverProfile";
import { url } from "./url";
import EveryActivetrcard from "./searchfortravel/EveryActivetrcard";
import DriverMessage from "./searchfortravel/DriverMessage";
import { isAuthenticationFailure } from "./utils/auth";

function App() {
  const {
    shownav,
    setShownav,
    setShoweverytravelcard,
    setShowhomecom,
    setShowmessagecom,
    setShowerrorpageforcode,
    setShowexit,
    showhistrinprogress,
    setShowhis,
    setShowhistrinprogress,
    setLoading,
    setShowerrortextcode,
    getmyprof,
    setGetmyprof,
    setShoweditprof,
    setGetprofloading,
    setShowtrinprogress,
    showtrinprogress,
  } = useContext(UseContext);


  const location = useLocation();
  const navigate = useNavigate();
  const addressofpage = location.pathname;

  // Re-fetch profile when the pending-approval screen asks for a status check.
  const [profileRefreshTick, setProfileRefreshTick] = useState(0);
  const [profileLoadError, setProfileLoadError] = useState(false);
  // An already-loaded profile is safe to keep during a temporary refresh failure.
  // Reading it through a ref avoids re-fetching immediately after setGetmyprof.
  const hasProfileRef = useRef(false);
  hasProfileRef.current = Boolean(getmyprof?._id);

  // Another existing flow (e.g. OTP verification) may finish its profile request
  // after this one failed. Accept that valid result rather than showing an error.
  useEffect(() => {
    if (profileLoadError && getmyprof?._id) setProfileLoadError(false);
  }, [profileLoadError, getmyprof?._id]);

  const retryProfile = useCallback(() => {
    if (!localStorage.getItem("token")) return;
    setProfileLoadError(false);
    if (!hasProfileRef.current) setGetprofloading(true);
    setProfileRefreshTick((tick) => tick + 1);
  }, [setGetprofloading]);

  // Only retry on connectivity/foreground events after an actual profile failure.
  useEffect(() => {
    if (!profileLoadError) return undefined;
    const onOnline = () => {
      if (navigator.onLine !== false) retryProfile();
    };
    const onVisible = () => {
      if (document.visibilityState === "visible") onOnline();
    };
    window.addEventListener("online", onOnline);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      window.removeEventListener("online", onOnline);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [profileLoadError, retryProfile]);
  useEffect(() => {
    const onPendingCheck = () => setProfileRefreshTick((tick) => tick + 1);
    window.addEventListener("mk:pending-approval-check", onPendingCheck);
    return () =>
      window.removeEventListener("mk:pending-approval-check", onPendingCheck);
  }, []);


  useEffect(() => {
    if (addressofpage === "/" || addressofpage === "/recievecode") {
      return;
    }

    const accessToken = localStorage.getItem("token");
    if (!accessToken) {
      setProfileLoadError(false);
      setGetprofloading(false);
      setShownav(false);
      navigate("/", { replace: true });
      return;
    }

    let cancelled = false;
    const controller = new AbortController();
    if (!hasProfileRef.current) setGetprofloading(true);
    setProfileLoadError(false);

    axios
      .get(`${url}/driver/v1/get-my-profile`, {
        timeout: 15000,
        signal: controller.signal,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        if (cancelled) return;
        if (!res.data?.data?._id) {
          throw new Error("Empty driver profile response");
        }
        setGetmyprof(res.data.data);
        setProfileLoadError(false);
        setGetprofloading(false);
      })
      .catch((error) => {
        if (cancelled) return;
        if (isAuthenticationFailure(error)) {
          setProfileLoadError(false);
          setGetprofloading(false);
          setGetmyprof({});
          setShownav(false);
          clearLocalStoragePreservingDeviceId();
          navigate("/", { replace: true });
          return;
        }

        // Timeouts, offline errors and 5xx responses must not log the driver out.
        // Do not render profile-dependent pages without a usable profile.
        setGetprofloading(false);
        if (!hasProfileRef.current) setProfileLoadError(true);
      });

    return () => {
      cancelled = true;
      controller.abort();
    };
  }, [addressofpage, profileRefreshTick, navigate, setGetmyprof, setGetprofloading, setShownav]);

  useEffect(() => {
    switch (addressofpage) {
      case "/Edit":
        setShownav(false);
        break;

      case "/home":
        setShowerrorpageforcode(false);
        setShoweverytravelcard(false);
        setShowhomecom(true);
        setShowmessagecom(false);
        setShowexit(false);
        setShoweditprof(false);

        if (localStorage.getItem("token") === null) {
          setShownav(false);
        } else {
          setShownav(true);
        }
        break;
      case "/history":
        setShowerrorpageforcode(false);
        setShowhomecom(false);
        setShoweditprof(false);
        setShowhistrinprogress(false);
        if (showtrinprogress === true) {
          setShowhis(false);
        } else {
          setShowhis(true);
          setShowtrinprogress(false);
        }
        setShowexit(false);
        if (localStorage.getItem("token") === null) {
          setShownav(false);
        } else {
          setShownav(true);
        }
        break;
      case "/report":
        setShowerrorpageforcode(false);
        setShowhomecom(true);
        setShowmessagecom(false);
        setShowexit(false);
        setShoweditprof(false);
        if (localStorage.getItem("token") === null) {
          setShownav(false);
        } else {
          setShownav(true);
        }
        break;
      case "/search":
        setShowerrorpageforcode(false);
        setShowexit(false);
        setShoweditprof(false);
        if (localStorage.getItem("token") === null) {
          setShownav(false);
        } else {
          setShownav(true);
        }
        break;
      case "/support":
        setShowerrorpageforcode(false);
        setShowexit(false);
        setShoweditprof(false);
        if (localStorage.getItem("token") === null) {
          setShownav(false);
        } else {
          setShownav(true);
        }
        break;
      case "/report/Message":
        setShownav(false);
        break;
      case "/history/travelhistory":
        setShownav(false);
        setShowerrortextcode(false);
        break;
      case "/home/travelinformation":
        setShownav(false);
        setShowerrortextcode(false);
        break;
      case "/UserandCarinformation":
        setShownav(false);
        break;
      default:
        setShownav(false);
    }
  }, [
    addressofpage,
    setShownav,
    setShowerrortextcode,
    setShowerrorpageforcode,
    setShowexit,
    setShowmessagecom,
    setShowhomecom,
    setShowhistrinprogress,
    setLoading,
    setShoweverytravelcard,
    setShowhis,
    showhistrinprogress,
    setShoweditprof,
    setShowtrinprogress,
    showtrinprogress,
  ]);

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      return undefined;
    }

    let cancelled = false;
    let unsubscribe = () => {};

    // On normal app loads we only synchronize an already-granted permission.
    // The permission prompt itself stays tied to the successful OTP login flow.
    requestForToken({ requestPermission: false });

    listenForForegroundMessages((payload) => {
      console.log("Foreground push message received:", payload);
    }).then((listenerUnsubscribe) => {
      if (cancelled) {
        listenerUnsubscribe();
        return;
      }
      unsubscribe = listenerUnsubscribe;
    });

    return () => {
      cancelled = true;
      unsubscribe();
    };
  }, [addressofpage]);
  return (
    <>
      {" "}
      <div className="marankoo-stage flex relative justify-center items-center lg:items-center lg:h-screen">
        <div
          className="marankoo-driver-shell lg:h-screen h-[100vh] flex flex-col items-center lg:w-1/3 w-full lg:border-gray-500 lg:border-[1px] lg:rounded-[10px]"
          data-route={addressofpage}
        >
          <>
            {profileLoadError && addressofpage !== "/" && addressofpage !== "/recievecode" ? (
              <div dir="rtl" role="alert" className="flex h-full w-full flex-col items-center justify-center gap-4 px-6 text-center">
                <p className="text-[18px] font-bold text-[#100E34]">دریافت اطلاعات راننده ناموفق بود</p>
                <p className="text-[14px] text-gray-600">اتصال اینترنت را بررسی کنید و دوباره تلاش کنید. اطلاعات ورود شما حفظ شده است.</p>
                <button
                  type="button"
                  onClick={retryProfile}
                  className="rounded-[10px] bg-[#100E34] px-8 py-3 text-white"
                >
                  تلاش مجدد
                </button>
              </div>
            ) : (
            <Routes>
              <Route path="/" element={<Logincom />} />
              <Route path="/search" element={<Search />}></Route>
              <Route path="/history" element={<Historycom />}></Route>
              <Route path="/home" element={<TravelCard />}></Route>
              <Route path="/report" element={<Reportcom />}></Route>
              <Route path="/support" element={<Supportcom />}></Route>
              <Route path="/recievecode" element={<Recievecode />}></Route>
              <Route
                path="/history/travelhistory/:id"
                element={<Everyhistravelcard />}
              ></Route>

              <Route
                path="/home/travelinformation/:id"
                element={<Everytravelcard />}
              ></Route>
              <Route
                path="/UserandCarinformation"
                element={<UserandCarinf />}
              ></Route>
              <Route path="/report/Message" element={<Messagecom />}></Route>
              <Route
                path="/EditDriverProfile"
                element={<EditDriverProfile />}
              ></Route>

              <Route
                path="/driverMessages/:id"
                element={<DriverMessage />}
              ></Route>

              <Route path="/Edit" element={<EditProfile />}></Route>
              <Route
                path="/history/Activetravel/:id"
                element={<EveryActivetrcard />}
              ></Route>
              <Route path="*" element={<Errorpage />} />
            </Routes>
            )}
            {!profileLoadError && shownav === true ? <Nav /> : <></>}
          </>
        </div>
      </div>
    </>
  );
}
export default App;
